import {
  SET_ASSISTANT_PAGES,
  SET_ASSISTANT_PAGES_LOADING,
  SET_ASSISTANT_PAGE,
  SET_ASSISTANT_OPEN,
  SET_CHAT_KIT_AVAILABILITY,
} from "./AssistantPagesActions";
import { Actions, IAssistantState } from "./interfaces";

const initialState = {
  isLoading: false,
  isSuccessOpen: false,
  assistantPages: [],
  assistantPage: {
    workflowId: "",
    workflowVersion: "",
    code: null,
    limits: {
      basic: {
        enabled: false,
        maxProperties: 0,
        maxRowsPerScope: 0,
      },
      pro: {
        enabled: false,
        maxProperties: 0,
        maxRowsPerScope: 0,
      },
      team: {
        enabled: false,
        maxProperties: 0,
        maxRowsPerScope: 0,
      },
    },
  },
  isChatKitAvailable: null,
};

const AssistantPagesReducer = (
  state: IAssistantState = initialState,
  action: Actions
) => {
  switch (action.type) {
    case SET_ASSISTANT_PAGES:
      return { ...state, assistantPages: action.payload };
    case SET_ASSISTANT_PAGES_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_ASSISTANT_PAGE:
      return {
        ...state,
        assistantPage: { ...state.assistantPage, ...action.payload },
      };
    case SET_ASSISTANT_OPEN:
      return {
        ...state,
        isSuccessOpen: action.payload,
      };
    case SET_CHAT_KIT_AVAILABILITY:
      return {
        ...state,
        isChatKitAvailable: {
          ...state.isChatKitAvailable,
          [action.payload.code]: action.payload.value,
        },
      };
    default:
      return state;
  }
};

export default AssistantPagesReducer;
